import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-article',
  templateUrl: './card-article.component.html',
  styleUrls: ['./card-article.component.css']
})
export class CardArticleComponent implements OnInit {

  @Input() sectionInfo;
  @Output() public callToAction = new EventEmitter();
  cta = {
    cta: null,
    productVariantId: null
  };
  
  constructor() {}

  ngOnInit(): void {
    !this.sectionInfo.imageUrl? this.sectionInfo.imageUrl = '../../assets/img/cards/2.jpg' : null;
    !this.sectionInfo.cardId? this.sectionInfo.cardId = 'A' : null;
  }

  callToActionButton(){
    this.cta.cta = 'buy';
    this.cta.productVariantId = this.sectionInfo.productVariantId;
    this.callToAction.emit(this.cta);
  }

}
